import type { HierarchyRectangularNode } from '@visx/hierarchy/lib/types.js';

import type { Unit } from '@dynatrace-sdk/units';

import { getTooltipItem } from './get-tooltip-item.js';
import type { Data } from '../../core/components/overlay-tooltip/types.js';
import type { Formatter } from '../../core/types/formatter.js';
import type { InternalTreeMapNode } from '../types/internal.js';

export const buildOverlayTooltipData = (
  node: HierarchyRectangularNode<InternalTreeMapNode>,
  formatter: Formatter,
  unit?: string | Unit,
): Data => {
  const item = getTooltipItem(formatter, node, unit);
  const parentName = node.parent?.data.name;
  const nodeColor =
    node.parent?.data.color?.Default ?? node.data?.color?.Default ?? '';

  return {
    geometry: 'treemap',
    header1: parentName ? [parentName] : [],
    metadata: { id: item.id, value: node.data.value },
    series: [
      {
        name: item.name,
        color: nodeColor,
        value: item.values[0],
      },
    ],
  };
};
